import React from 'react';
import classNames from 'classnames';
import styles from './SVGIcon.scss';

export default function ContractsIcon({ className, size }) {
  return (
    <span className={classNames(styles.svgIcon, className, styles[size])}>
      <svg viewBox="0 0 24 24" fill="var(--color-icon-lineart)">
        <path d="M20,22H4a3,3,0,0,1-3-3V9A3,3,0,0,1,4,6H20a3,3,0,0,1,3,3V19A3,3,0,0,1,20,22ZM4,8A1,1,0,0,0,3,9V19a1,1,0,0,0,1,1H20a1,1,0,0,0,1-1V9a1,1,0,0,0-1-1Z" />
        <path d="M16,8a1,1,0,0,1-1-1V5a1,1,0,0,0-1-1H10A1,1,0,0,0,9,5V7A1,1,0,0,1,7,7V5a3,3,0,0,1,3-3h4a3,3,0,0,1,3,3V7A1,1,0,0,1,16,8Z" />
        <path d="M13,13H11a1,1,0,0,1,0-2h2a1,1,0,0,1,0,2Z" />
        <path d="M12,17C6.53,17,1,15.28,1,12a1,1,0,0,1,2,0c0,1.22,3.51,3,9,3s9-1.78,9-3a1,1,0,0,1,2,0C23,15.28,17.47,17,12,17Z" />
      </svg>
    </span>
  );
}
